import Accounting from "../Accounting";
import Actions from "../Actions";
import Art from "../Art";
import Characteristics from "../Characteristics";
import Emission from "../Emission";

function Body() {
  return (
    <>
      <Characteristics />
      <Accounting />
      <Emission />
      <Art />
      <Actions />
    </>
  );
}

export default Body;
